import { Component, HostListener } from '@angular/core';

import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-blocking-loading-spinner',
  imports: [UiCoreModule],
  templateUrl: './blocking-loading-spinner.component.html',
  styleUrls: ['./blocking-loading-spinner.component.css'],
})
export class BlockingLoadingSpinnerComponent {
  @HostListener('keydown.enter', ['$event'])
  @HostListener('document:click', ['$event'])
  onEnter(event: MouseEvent | KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
